import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { addDays, format, subYears } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import { ExclusionTime } from '../../../shared/definitions';
import { toTimestamp } from '../../../shared/utils';
import { ExclusionType } from '../../definitions';
import type { ExclusionResponseProps } from '../../definitions';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_3,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_YouXll_be_able_to_request_to_r_ELL
} from './DefaultSelfExclusionResponse.messages.json';

interface Props extends ExclusionResponseProps {
  banEndDate?: string;
}

const DefaultSelfExclusionResponse: React.FC<Props> = ({
  daysRequested,
  exclusionType,
  endDate,
  banEndDate
}) => {
  const site = useSelector(select.cms.getSiteId);
  const allowAccountReopeningRequest = useSelector(select.account.allowAccountReopeningRequest);

  const indefiniteExclusion = daysRequested === ExclusionTime.Indefinite;
  const indefiniteExclusionEndDate =
    site === Sites.ITA
      ? addDays(new Date(), ExclusionTime.HundredEightyDays)
      : subYears(endDate, 99);
  const showAccountReopeningText =
    allowAccountReopeningRequest || exclusionType !== ExclusionType.SelfExclusion;
  const isOneYearExclusionOnSWE = site === Sites.SWE && daysRequested === ExclusionTime.OneYear;

  const getExclusionEndDate = () => {
    switch (true) {
      case indefiniteExclusion:
        return indefiniteExclusionEndDate;
      case isOneYearExclusionOnSWE:
        return banEndDate ? toTimestamp(JSON.parse(banEndDate)) : new Date();
      default:
        return endDate;
    }
  };

  return (
    <div>
      <Translation
        {...(indefiniteExclusion || isOneYearExclusionOnSWE
          ? TXTWCL_This_means_you_wonXt_be_able_t_ELL_3
          : TXTWCL_This_means_you_wonXt_be_able_t_ELL_5)}
        values={{
          0: <b>{format(getExclusionEndDate(), 'Pp')}</b>
        }}
      />{' '}
      {!indefiniteExclusion && showAccountReopeningText && (
        <>
          <Translation
            {...TXTWCL_YouXll_be_able_to_request_to_r_ELL}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />{' '}
        </>
      )}
    </div>
  );
};

export default DefaultSelfExclusionResponse;
